import axios from "axios";
const prefix = process.env.NODE_ENV == "development" ? "" : "https://news.nbd.com.cn";
export default {
    calSingleResonance(code) {
        return axios.get(prefix + `/stock-data-service/dimension/market/calSingleResonance?code=${code}`);
    }
}